import React from 'react';

interface TableHeaderProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  children,
  className = '',
  align = 'left'
}) => {
  const alignmentClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  }[align];

  return (
    <th
      scope="col"
      className={`px-6 py-3 bg-gray-50 text-xs font-medium text-gray-500 uppercase tracking-wider ${alignmentClass} ${className}`}
    >
      {children}
    </th>
  );
};
